import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";

export default function ThankYou() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;

    script.innerHTML = `
      gtag('event', 'conversion', {
          'send_to': 'AW-16526784140/OtWqCKKAzq8aEIztysg9',
          'value': 5000.0,
          'currency': 'INR'
      });
    `;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Helmet>
        <script>
          {`
           gtag('event', 'conversion', {
                'send_to': 'AW-16707770699/SZAnCIKjkdgZEMuy8Z4-',
                'value': 1.0,
                'currency': 'INR'
            });
          `}
        </script>
      </Helmet>
      <section className="thankyou-area header-gap">
        <img
          src="./assets/home/thankyou-background.webp"
          className="img-responsive thanks-image"
          alt="thank you"
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="thankyou-content-box">
                <div className="thankyou-message">
                  <img
                    className="img-responsive"
                    src="./assets/home/thankyou-message.webp"
                    alt="thanks"
                  />
                </div>
                <h1 className="heading">Thanks for submitting!</h1>
                <p>We have received your information successfully.</p>
                <p>Our customer representative will reach out to you shortly to assist you further.</p>
                {/* <Link to={"/"} className="default-btn">
                  Go Home
                </Link> */}

                <h2 className="heading">What would you like to do next?</h2>
                <div>
                  <Link className="default-btn" to={"/"}>Go to Homepage</Link>
                  <Link className="default-btn" to={"/blog"}>Explore Our Blogs</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
